/** @format */
import React from 'react';

import copyToClipboard from 'copy-to-clipboard/index';

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false
        };
    }

    handleCopy = () => {
        copyToClipboard(this.props.content);
        this.setState({active: true}, this.handleReset);
    };

    handleReset = () => {
        if (typeof this.resetTimeout != 'undefined') {
            clearTimeout(this.resetTimeout);
        }

        this.resetTimeout = setTimeout(() => {
            this.setState({active: false});
        }, 1500);
    };

    render() {
        if (this.state.active) {
            return (
                <button
                    className="btn btn-link tw-p-0 tw-ml-2"
                    style={{textDecoration: 'none'}}
                    onClick={this.handleCopy}>
                    <i className="fa fa-check" />
                    <span> Copied!</span>
                </button>
            );
        }
        return (
            <button className="btn btn-link tw-p-0 tw-ml-2" onClick={this.handleCopy}>
                <i className="fa fa-copy" />
            </button>
        );
    }
}
